import {
    ChangeDetectionStrategy,
    Component,
} from '@angular/core';
import { UiModalComponent } from '@components/ui-modal/ui-modal.component';
import { IRole } from '@models';

@Component({
    templateUrl: './role-users.modal.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RoleUsersModalComponent
    extends UiModalComponent<IRole> {
}
